import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import MapIcon from '@mui/icons-material/Map';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { useAppSelector } from 'app/hooks';
import Col from 'blocks/Col';
import Row from 'blocks/Row';
import Routes from 'config/routes-constant';
import { toggleDrawer, useLayoutDispatch } from 'context/HamberProvider';
import cookie from 'helper/cookie';
import Paths from 'helper/paths';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { NavLink, useNavigate } from 'react-router-dom';
import { resetDashboard } from 'store/dashboard/dasboardSlice';
import { UserTierState, resetUserTier } from 'store/tiers/tiersSlice';
import * as S from '../SidebarItems/sidebarItems.styles';
const SidebarItem = () => {
  const userTiers = useAppSelector(UserTierState);
  const LayoutDispatch = useLayoutDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = location;
  const links = [
    {
      key: 'dashboard',
      url: Routes.dashboard,
      icon: <DashboardIcon />,
      isActive: pathname.includes(Paths.Main.index().route),
    },
    {
      key: 'profile',
      url: Routes.profile,
      icon: <AccountCircleOutlinedIcon />,
      isActive: pathname.includes(Paths.Profile.index().route),
    },
    {
      key: 'viewMiles',
      url: Routes.viewMiles,
      icon: <MapIcon />,
      isActive: pathname.includes(Paths.Miles.index().route),
    },

    {
      key: 'claimMiles',
      url: Routes.claimMiles,
      icon: <AirplanemodeActiveIcon />,
      isActive: pathname.includes(Paths.Miles.claim().route),
    },
    {
      key: 'calculation',
      url: Routes.calculation,
      icon: <CalculateOutlinedIcon />,
      isActive: pathname.includes(Paths.Miles.calculation().route),
    },

    {
      key: 'tickets',
      url: Routes.tickets,
      icon: <QuestionAnswerIcon />,
      isActive: pathname.includes(Paths.Tickets.index().route),
    },
    {
      key: 'services',
      url: Routes.services,
      icon: <BusinessCenterOutlinedIcon />,
      isActive: pathname.includes(Paths.Services.index().route),
    },
  ];

  if (userTiers?.Tier.type === 'ADT') {
    links.push({
      key: 'supervision',
      url: Routes.supervision,
      icon: <FamilyRestroomIcon />,
      isActive: pathname.includes(Paths.Supervision.index().route),
    });
  }
  const logout = () => {
    cookie.clean();
    dispatch(resetDashboard());
    dispatch(resetUserTier());
    navigate(Paths.Login.index().route);
  };
  return (
    <S.SliderBarList as={Col}>
      {links.map((item, index) => (
        <S.SliderBarListItem
          as={NavLink}
          to={item.url}
          key={index}
          onClick={() => {
            toggleDrawer(LayoutDispatch);
          }}
        >
          <Row align="center">
            <S.SliderBarListItemSvg $active={item.isActive}>{item.icon}</S.SliderBarListItemSvg>
            <S.SliderBarListItemSpan $active={item.isActive}>
              {t(`layout.mainMenu.${item.key}`)}
            </S.SliderBarListItemSpan>
          </Row>
        </S.SliderBarListItem>
      ))}
      <S.SliderBarListItem>
        <a href={`https://iranair.com/sky-gift`} target="_blank" style={{ display: 'flex', alignItems: 'center' }}>
          <S.SliderBarListItemSvg as={LoyaltyIcon} />
          <S.SliderBarListItemSpan>{t(`layout.mainMenu.Loyal`)}</S.SliderBarListItemSpan>
        </a>
      </S.SliderBarListItem>

      <S.SliderBarListItem>
        <Row align="center" onClick={logout}>
          <S.SliderBarListItemSvg as={LogoutOutlinedIcon} />
          <S.SliderBarListItemSpan>{t(`layout.mainMenu.logout`)}</S.SliderBarListItemSpan>
        </Row>
      </S.SliderBarListItem>
    </S.SliderBarList>
  );
};

export default SidebarItem;
